<template>
  <Container>
    <GetStartedInstructions
      :class="$style.recommendedPolicyGroups"
      dismissButtonClass=""
      dismissButtonText="dismiss forever"
      :showDismiss="true"
      :startCollapsed="false"
      :title="componentTitle"
    >
      <div
        :class="$style.centerText"
      >
        <HeadingSmall
          :class="$style.title"
        >
          <PremiumFeatureIcon
            :featureCode="$options.trialFeatures.osPatchManagement.featureCode"
          />
          Load Patch Management Policy Groups
        </HeadingSmall>
        <ParagraphBody
          :class="$style.centerText"
        >
          Simplify cross platform patch management using default groups.
          <Link
            href="https://jumpcloud-support.force.com/support/s/article/Default-Policy-Groups"
            target="_blank"
            text="Learn More"
          />
        </ParagraphBody>
        <Button
          :class="$style.loadBtn"
          text="Load Default Policies & Policy Groups"
          @click="handleDefaultPolicies"
        />
      </div>
    </GetStartedInstructions>
  </Container>
</template>

<script>
import {
  Button,
  Container,
  HeadingSmall,
  Link,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import GetStartedInstructions from 'components/GetStartedInstructions/GetStartedInstructions.vue';
import PoliciesMixin from 'client/OsManagement/mixins/PoliciesMixin';
import PremiumFeatureIcon from 'client/components/Badges/PremiumFeatureIcon';
import RecommendedPolicyGroupsData from 'client/util/Constants/RecommendedPolicyGroupsConstants';

const configurationGroupModel = StoreModelMap[ItemTypeConsts.configurationGroup];
const groupCollection = StoreModuleMap[ItemTypeConsts.configurationGroup];
const storeModule = StoreModuleMap[ItemTypeConsts.policy];
const policyTemplateCollection = StoreModuleMap[ItemTypeConsts.policyTemplate];
const storeModel = StoreModelMap[ItemTypeConsts.configuration];

export default {
  name: 'RecommendedPolicyGroups',

  components: {
    Button,
    Container,
    HeadingSmall,
    GetStartedInstructions,
    Link,
    ParagraphBody,
    PremiumFeatureIcon,
  },

  trialFeatures,

  mixins: [
    PoliciesMixin,
  ],

  data: () => ({
    policiesConfigFields: {},
    setLoadingOverlay: false,
  }),

  computed: {
    ...mapGetters(policyTemplateCollection, {
      policyTemplates: 'getCollection',
    }),

    componentTitle() {
      return `Recommended policy groups (${RecommendedPolicyGroupsData.length})`;
    },
  },

  methods: {
    ...mapActions(storeModule, [
      'deleteItems',
      'fetchCollection',
    ]),

    ...mapActions(configurationGroupModel, [
      'bulkCreateDefaultPolicyGroups',
    ]),

    ...mapActions(groupCollection, [
      'refreshCollection',
    ]),

    ...mapActions(storeModel, [
      'fetchItem',
    ]),

    async handleDefaultPolicies() {
      this.$emit('loadDefaultGroupsBtn', true);
      this.policiesConfigFields = await this.getConfigFields();

      await this.createDefaultPoliciesAndPolicyGroups(
        this.policiesConfigFields,
        this.policyTemplates,
      );

      this.$emit('loadDefaultGroupsBtn', false);
      await this.refreshCollection();
    },
  },
};
</script>

<style module>
.recommendedPolicyGroups ul {
  display: block;
}

.recommendedPolicyGroups button:not(.loadBtn) {
  background: none;
  border: 0;

  /*
    This !important is to overwrite this line https://github.com/TheJumpCloud/jumpcloud-admin-portal/blob/master/client/components/Buttons/FlatActionStyles.css#L4
  */
  color: var(--jcGrey) !important;
  font-weight: 400;
  text-decoration: underline;
}

.centerText {
  text-align: center;
}

.title {
  margin-bottom: 10px;
}

.premiumIcon.premiumIcon.premiumIcon {
  background-color: var(--jcTertiary50);
  border: 1px solid var(--jcTertiary50);
  border-radius: 0.313rem;
  display: inline-block;
  font-size: 1rem;
  height: 1.5rem;
  margin-right: 0.75rem;
  padding-top: 0.15rem;
  text-align: center;
  width: 1.5rem;
}

</style>
